// extracted by mini-css-extract-plugin
module.exports = {"activeNav":"Header-module--activeNav--25noA","mainNav":"Header-module--main-nav--2C0n8"};